<template>
  <div class="box">
    <h1>Text Repeater</h1>
    <div class="my-app">
      <div class="my-input">
        <label for="input">ORIGINAL TEXT</label>
        <textarea
          id="input"
          class="input"
          cols="30"
          rows="10"
          v-model="text"
        ></textarea>
        <p>Characters Count: {{ charactersCount }}</p>
        <div class="options">
          <div class="line">
            <span @click="toggle" class="selected" id="s1">Same line</span>
            <span @click="toggle" id="s2">One per line</span>
          </div>
          <label for="separator">Separator:</label>
          <input
            id="separator"
            class="separator"
            type="text"
            v-model="separator"
          />
          <label for="number">How many times?</label>
          <input
            onpaste="return false;"
            min="0"
            max="7000"
            id="number"
            type="number"
            class="number"
            v-model="number"
          />
        </div>
        <button @click="clear" id="clear-button" class="clear-button">
          Clear
        </button>
      </div>
      <div class="my-output">
        <label v-if="showOutput" for="output">OUTPUT</label>
        <textarea
          disabled
          class="output"
          v-if="showOutput"
          id="output"
          cols="30"
          rows="10"
          v-model="newText"
        ></textarea>
        <pre v-show="showOutput" id="repeated"></pre>
        <button v-if="showOutput" @click="copy" id="button" class="copy-button">
          Copy
        </button>
      </div>
    </div>
    <div class="footer">
      <p>Made With ❤️ By Yassine Maamri</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      text: "",
      separator: "",
      number: 0,
      selected: "s1",
    };
  },
  computed: {
    newText() {
      let ch = this.text;
      let nch = "";
      let repeated = 0;
      for (let i = 0; i < this.number; i++) {
        if (nch.length + this.separator.length + ch.length >= 7000) {
          document.getElementById("input").setAttribute("disabled", "");
          document.getElementById("separator").setAttribute("disabled", "");
          document.getElementById("number").setAttribute("disabled", "");
          break;
        }
        if (this.selected == "s1") {
          nch = nch + this.separator + ch;
        } else if (this.selected == "s2") {
          nch = nch + this.separator + "\n" + ch;
        }
        if (
          nch === " " + ch ||
          (nch.startsWith(this.separator) && this.separator != "") ||
          nch.startsWith("\n")
        ) {
          nch = ch;
        }
        repeated = repeated + 1;
        document.getElementById(
          "repeated"
        ).innerHTML = `Characters count: ${nch.length}/7000
Your text repeated: ${repeated} times`;
      }
      return nch;
    },
    charactersCount() {
      return this.text.length;
    },
    showOutput() {
      if (this.number > 0 && this.text !== "") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    toggle() {
      let s1 = document.getElementById("s1");
      let s2 = document.getElementById("s2");
      if (s1.classList.contains("selected")) {
        s1.classList.remove("selected");
        s2.classList.add("selected");
        this.selected = "s2";
      } else {
        s2.classList.remove("selected");
        s1.classList.add("selected");
        this.selected = "s1";
      }
    },
    copy() {
      /* Get the text field */
      var copyText = document.getElementById("output");
      /* Select the text field */
      copyText.select();
      copyText.setSelectionRange(0, 99999); /* For mobile devices */
      /* Copy the text inside the text field */
      navigator.clipboard.writeText(copyText.value);
      /* Alert the copied text */
      alert("Text copied");
    },
    clear() {
      console.log("hi");
      this.text = "";
      this.number = 0;
      this.separator = "";
      this.selected = "s1";
      let s1 = document.getElementById("s1");
      let s2 = document.getElementById("s2");
      s2.classList.remove("selected");
      s1.classList.add("selected");
      document.getElementById("input").removeAttribute("disabled");
      document.getElementById("separator").removeAttribute("disabled");
      document.getElementById("number").removeAttribute("disabled");
    },
  },
};
</script>
<style >
* {
  margin: 0;
}
.box {
  margin: 0;
  background-color: #f1f1f1;
}
.box h1 {
  text-align: center;
  font-size: 27px;
  font-weight: bold;
  color: #5581b5;
  margin-bottom: 30px;
  padding-top: 30px;
}
.my-app {
  width: 60%;
  margin: auto;
  min-height: 100vh;
  background-color: white;
  padding: 30px;
}
.box .my-app .my-input .options {
  display: flex;
  justify-content: space-evenly;
}
@media (max-width: 1239px) {
  .box .my-app .my-input .options {
    flex-direction: column;
  }
  .box .my-app .my-input .options .separator,
  .number {
    width: 150px;
    margin-bottom: 13px !important;
  }
  .box .my-app .my-input .options .line {
    margin-bottom: 13px;
  }
}
.box .my-app p,
pre {
  margin: 10px;
}
.box .my-app .my-input .options .separator,
.number {
  padding: 12px 20px;
  margin: 8px 0;
  height: 10px;
  box-sizing: border-box;
}
.box .my-app label[for="input"],
label[for="output"] {
  font-weight: bold;
  background-color: #f1f1f1;
  padding: 1px;
}

.my-input {
  margin-bottom: 30px;
}

.input {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
}
.output {
  width: 100%;
  height: 150px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 2px solid #ccc;
  border-radius: 4px;
  background-color: #f8f8f8;
  font-size: 16px;
  resize: none;
}

textarea,
input {
  display: block;
}
.box .my-app .my-output .copy-button {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
}
.box .my-app .my-input .clear-button {
  background-color: #4caf50;
  border: none;
  color: white;
  padding: 7px 16px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 14px;
  margin-top: 10px;
}
.line span {
  display: inline-block;
  background-color: white;
  border-radius: 10px;
  border: 1px double #cccccc;
  color: black;
  text-align: center;
  font-size: 16px;
  padding: 5px;
  width: fit-content;
  cursor: pointer;
  margin: 3px;
}
.selected {
  border: 1px double black !important;
  background-color: rgb(250, 250, 250) !important;
}
.footer {
  height: 60px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  background-color: #f5f5f5;
  margin-top: 20px;
}
.footer p {
  text-align: center;
  color: black;
  font-weight: 300;
  font-size: 15px;
}
</style>
